import { Reducer } from 'redux';
import { WorkZoneSearchActionTypes } from './actions';

// Type-safe initialState!
const initialState = {
  results: []
};

type IWorkZoneSearchStoreState = Readonly<typeof initialState>;

const reducer: Reducer<IWorkZoneSearchStoreState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case WorkZoneSearchActionTypes.SEARCH: {
      let _state = { ...state };
      _state = { ..._state, results: action.value };
      return _state;
    }
    case WorkZoneSearchActionTypes.UPDATE: {
      let _state = { ...state };
      _state = { ..._state, results: action.value };
      return _state;
    }
    case WorkZoneSearchActionTypes.UPDATE_NDOT_WZ_FLAG: {
      let _state = { ...state };
      _state = { ..._state, results: action.value };
      return _state;
    }
    case WorkZoneSearchActionTypes.GET_IMAGE: {
    //   stuff
    }
    default: {
      return state;
    }
  }
};

export default reducer;
